import { render, staticRenderFns } from "./IndustrialPropertyFields.vue?vue&type=template&id=63ba1c30&scoped=true"
import script from "./IndustrialPropertyFields.vue?vue&type=script&lang=js"
export * from "./IndustrialPropertyFields.vue?vue&type=script&lang=js"
import style0 from "./IndustrialPropertyFields.vue?vue&type=style&index=0&id=63ba1c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1c30",
  null
  
)

export default component.exports